var B = /* @__PURE__ */ ((A) => (A[A.CAR = 1] = "CAR", A[A.BIKE = 2] = "BIKE", A))(B || {});
export {
  B as FavoriteVehicleTypeDTO
};
